import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Invoice } from 'services/action';

import { Page, Button } from 'ui/components';
import { FormGeneral, FormOrders } from './component/form';

const initialState = {
  general: null,
  orders: null,
  isLoading: true,
};

const CreateScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ general, orders, isLoading }, setState] =
    React.useState(initialState);

  const $handleSubmit = async (e) => {
    const payload = {
      customer_id: general?.customer?.id,
      term_of_payment: general?.term_of_payment?.value || 0,
      schedule_at: general?.schedule_at?.formatted,
      due_at: general?.due_at?.formatted,
      billing_to: general?.billing_to,
      billing_address: general?.billing_address,
      discount: general?.calculate?.discount,
      ppn: general?.calculate?.ppn,
      orders
    };

    const req = await Dispatch(Invoice.$create(payload));

    if (req?.message === 'success') {
      History?.push(`/invoice/${req?.data?.id}`);
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  return (
    <Page type="form" onSubmit={$handleSubmit} className="detail-fixed">
      <Page.Header title="Buat Invoice" className="bg-light" />

      <Page.Body className="row px-3 border-top">
        <div
          className="col-12 col-md-4 position-md-fixed "
          style={{ paddingRight: 10 }}
        >
          <FormGeneral
            onChange={(e) =>
              setState((prevState) => ({ ...prevState, general: e }))
            }
            isLoading={isLoading}
            orders={orders}
          />
        </div>
        <div className="col-md-8 col-12 offset-md-4 border-start border-sm-none ps-0 pe-0">
          <div className="py-md-3 ps-md-3 ">
            <FormOrders
              isLoading={isLoading}
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, orders: e }))
              }
              customer={general?.customer}
            />
          </div>
        </div>
      </Page.Body>
      <Page.Footer className="bg-light justify-content-center gap-md-2 pt-2 pb-3 mb-2 mb-md-0 border-top d-md-flex d-block flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/invoice`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;
